module.exports = __webpack_public_path__ + "static/media/passed-hors-doeuvres-party.5b10efb9.jpg";